const state = {
    tabDef: {
        pageNum: 1,
        pageSize: 10,
        sortMap: {},
        params: {},
    },
    mailId: '',
    tab: {},
    status: [],
    siteList: [],
    letterType: [],
    dep: [],
    letterFrom: [],
    contentTypeList: [],
    fileType: '',
    fileSize: '',
    role: {},
    sensitiveName: '',
    sensitiveNum: '',
    isBadWrods: false,
    exportList: [],
    letterIds: '',
    downloadNewArr: [],
    pageFrom: '',
    loading: false,
    // 湖南版本特有弹框数据
    propsData: {},
    uncheck: {}
}

const actions = {
    // 表格数据(信件受理)
    async getTab({ commit, state }) {
        let res = {};
        if (state.pageFrom == 'entrust' || state.pageFrom == 'handover') {
            res = await GetPageListDataEntrust(state.tabDef);
        } else {
            res = await GetPageListData(state.tabDef);
        }
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateTab', res.data);
        }
    },
    // 信件状态
    async getStatus({ commit, state }) {
        const res = await GetDictByConditionList(state.tabDef);
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updatePageNeedParams', { bizType: '' });
            commit('updateStatus', res.data.rows);
        }
    },
    // 所属站点
    async getSite({ commit }) {
        const res = await getSiteInfo();
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateSite', res.data);
        }

    },
    // 信件类型
    async getLetterType({ commit, state }) {
        commit('updatePageNeedParams', { bizType: 'BIZ_MAIL_INFO.OBJECTIVE_TYPE', isDel: 0 });
        const res = await GetLetterSelectType(state.tabDef);
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updatePageNeedParams', { bizType: '' });
            commit('updateLetterType', res.data.rows);
        }
    },
    // 处理部门
    async getDep({ commit }) {
        const res = await HandleMailDepts();
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateDep', res.data);
        }
    },
    // 信件来源
    async getLetterFrom({ commit, state }) {
        commit('updatePageNeedParams', { bizType: 'BIZ_MAIL_INFO.SOURCE_ID' });
        const res = await GetDictByConditionList(state.tabDef);
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updatePageNeedParams', { bizType: '' });
            commit('updateLetterFrom', res.data.rows);
        }
    },
    // 内容类别
    async getContentType({ commit }) {
        const res = await GetSelectContentListData();
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateContentType', res.data);
        }
    },
    // 上传文件类型
    async getFileType({ commit }) {
        const res = await mailFileLimit();
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateFileType', res.data);
        }
    },
    // 检测敏感词汇
    async checkWords({ commit, state }) {
        const res = await checkContent({ content: state.role.content });
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateCheckContent', res.data);
        }
    },
    // 新建信件
    async getAddNewLetter({ state }) {
        const res = await letterService.addNewLetter(state.role);
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            Message({
                message: '保存成功',
                type: res.status
            });
        }
    },
    // 导出全部excel
    async downloadExcelAsync({ state }) {
        await getExcelContentNew(state.tabDef);
    },
    // 导出选中excel
    async downloadSelectExcelAsync({ state, commit }) {
        const res = await getExcelContent({ ids: state.letterIds });
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updateDownloadSelectExcel', res.data);
        }
    },
    // 废弃信件
    async delLetter({ state }) {
        const res = await letterService.delSomeoneLetter({ mailId: state.mailId });
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            Message({
                message: res.data,
                type: res.status
            });
        }
    },
    // 湖南特有弹框请求
    async getPropsData({ commit }) {
        const res = await msgInit();
        if (res.status === "success") {
            if (res.data.errorCode == "403") window.location.href = res.data.casLoginUrl;
            commit('updatePropsData', res.data);
        }
    },

}

const mutations = {
    updateTab: (state, payload) => state.tab = payload,
    updateSite: (state, payload) => {
        state.siteList = payload;
        window.sessionStorage.setItem('site', JSON.stringify(payload));
    },
    updateStatus: (state, payload) => state.status = payload,
    updateLetterType: (state, payload) => {
        state.letterType = payload;
        window.sessionStorage.setItem('letterType', JSON.stringify(payload));
    },
    updateDep: (state, payload) => state.dep = payload,
    updateLetterFrom: (state, payload) => {
        state.letterFrom = payload;
        window.sessionStorage.setItem('letterFrom', JSON.stringify(payload));
    },
    updateContentType: (state, payload) => {
        state.contentTypeList = payload;
        window.sessionStorage.setItem('contentType', JSON.stringify(payload));
    },
    updateTabDef: (state, payload) => {
        let pageParamsObj = {};
        if (state.pageFrom == 'new') {
            pageParamsObj = { isNew: state.tabDef.params.isNew };
        } else if (state.pageFrom == 'overDue') {
            pageParamsObj = { isNew: state.tabDef.params.isOverDue };
        } else if (state.pageFrom == 'handover' || state.pageFrom == 'entrust') {
            pageParamsObj = { type: state.tabDef.params.type };
        } else if (state.pageFrom == 'accept') {
            pageParamsObj = {};
        } else {
            pageParamsObj = { status: state.tabDef.params.status }
        }
        state.tabDef.params = payload;
        state.tabDef.pageNum = 1;
        state.tabDef.pageSize = 10;
        Object.assign(state.tabDef.params, pageParamsObj);
    },
    updateSort: (state, payload) => state.tabDef.sortMap = payload,
    updateFileType: (state, payload) => {
        let result = JSON.parse(payload[0].businessName);
        state.fileType = result.type;
        state.fileSize = result.size / 1024 / 1024;
        var arr = state.fileType.split(",");
        for (var i = 0; i <= arr.length - 1; i++) {
            arr[i] = "." + arr[i];
        }
        var str = arr.join(",");
        state.fileType = str;
    },
    updateCheckContent: (state, payload) => {
        const { content, flag } = payload;
        if (content != null) {
            for (let i in content) {
                state.sensitiveName = i;
                state.sensitiveNum = content[i];
            }
        }
        state.isBadWrods = flag;
    },
    updateDownloadSelectExcel: (state, payload) => {
        state.downloadNewArr = payload;
        state.downloadNewArr.map(item => {
            if (item.mailInfo.isPublic === 0) {
                item.mailInfo.isPublic = "否";
            } else {
                item.mailInfo.isPublic = "是";
            }
            if (item.mailReply.length > 0) {
                item.mailInfo.replyContent = item.mailReply;
            }
            item.mailInfo.fromIdCard += " ";
            item.mailInfo.serialNumber += " ";
            return item;
        });
    },
    updatePageFrom: (state, payload) => state.pageFrom = payload,
    updatePageNeedParams: (state, payload) => {
        Object.assign(state.tabDef.params, payload);
        if (payload.bizType == '') delete state.tabDef.params.bizType;
        if (payload.type == '') delete state.tabDef.params.type;
        if (payload.isNew == '') delete state.tabDef.params.isNew;
        if (payload.status == '') delete state.tabDef.params.status;
        if (payload.isOverDue == '') delete state.tabDef.params.isOverDue;
    },
    updateLoading: (state, payload) => state.loading = payload,
    // 特有弹框
    updatePropsData: (state, payload) => state.propsData = payload,
    updateBackTableDefParams: (state, payload) => {
        state.tabDef.pageSize = payload.pageSize;
        state.tabDef.pageNum = payload.pageNum;
    },
    // 导航栏未读
    SAVE_UNCHECK: (state, payload) => state.uncheck = payload
}

import { GetPageListData, GetPageListDataEntrust, GetDictByConditionList, getSiteInfo, GetLetterSelectType, HandleMailDepts, GetSelectContentListData, mailFileLimit, checkContent, letterService, getExcelContentNew, getExcelContent, acceptLetterRightDownProp, msgInit } from '@/api/allactions';
import { Message } from 'element-ui';
export default {
    namespaced: true,
    state,
    actions,
    mutations
}